var _style, _defs, _defs2, _g, _defs3, _defs4, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 30",
    style: {
      enableBackground: "new 0 0 110 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_3_);}\r\n\t.st1{enable-background:new    ;}\r\n\t.st2{clip-path:url(#SVGID_7_);}\r\n\t.st3{fill:#CEC18C;}\r\n\t.st4{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("line", {
    id: "SVGID_1_",
    x1: 0,
    y1: 30,
    x2: 0,
    y2: 0
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("line", {
    id: "SVGID_2_",
    x1: 110,
    y1: 0,
    x2: 110,
    y2: 30
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_2_",
    style: {
      overflow: "visible"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    transform: "translate(15 15)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M106,31"
  }))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_6_",
    d: "M-4,31"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_7_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_6_",
    style: {
      overflow: "visible"
    }
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Tag_Rock",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4_2_",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-2_1_",
    className: "st3",
    d: "M15,0h80c8.3,0,15,6.7,15,15l0,0c0,8.3-6.7,15-15,15H15C6.7,30,0,23.3,0,15l0,0 C0,6.7,6.7,0,15,0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    className: "st4",
    d: "M4.7,6.6L1,5.3l6.5-4.4c0.1-0.1,0.2,0,0.3,0.1c0,0,0,0,0,0l1.5,2.2c0.1,0.1,0,0.2-0.1,0.3 L4.9,6.5C4.8,6.6,4.8,6.6,4.7,6.6C4.7,6.6,4.7,6.6,4.7,6.6z M-0.6,5L-3.9,4C-3.9,3.9-4,3.9-4,3.8V0.4c0,0,0-0.1,0-0.1l5.1-6.2 c0,0,0.1-0.1,0.2-0.1h6.6C8-6,8.1-5.9,8.1-5.8c0,0,0,0,0,0L7.3-0.4c0,0.1,0,0.1-0.1,0.1L-0.4,5C-0.4,5-0.5,5-0.6,5 C-0.6,5-0.6,5-0.6,5L-0.6,5z M10.2,2.4L8.4,0c0,0,0-0.1,0-0.2l1-5.7C9.4-5.9,9.5-6,9.6-6l0,0c0.1,0,0.2,0.1,0.2,0.1l2.2,7 c0,0.1,0,0.2-0.1,0.2l-1.4,1.1C10.4,2.6,10.3,2.5,10.2,2.4C10.2,2.5,10.2,2.4,10.2,2.4L10.2,2.4z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M46.4,16.7h-1.6v3.6h-2.1v-10h3.7c1.2,0,2.1,0.3,2.7,0.8s1,1.3,1,2.2c0,0.7-0.1,1.2-0.4,1.7s-0.7,0.8-1.3,1.1 l2.2,4.1v0.1h-2.2L46.4,16.7z M44.8,15h1.7c0.5,0,0.9-0.1,1.2-0.4s0.4-0.6,0.4-1.1c0-0.5-0.1-0.8-0.4-1.1S47,12,46.4,12h-1.6V15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M59.8,15.6c0,1-0.2,1.8-0.5,2.6s-0.8,1.3-1.5,1.7c-0.6,0.4-1.4,0.6-2.2,0.6c-0.8,0-1.6-0.2-2.2-0.6 s-1.1-1-1.5-1.7s-0.5-1.6-0.5-2.5v-0.5c0-1,0.2-1.8,0.5-2.6s0.9-1.3,1.5-1.7s1.4-0.6,2.2-0.6c0.8,0,1.6,0.2,2.2,0.6 c0.6,0.4,1.1,1,1.5,1.7c0.4,0.7,0.5,1.6,0.5,2.6V15.6z M57.8,15.1c0-1-0.2-1.8-0.6-2.4s-0.9-0.8-1.6-0.8c-0.7,0-1.2,0.3-1.6,0.8 s-0.6,1.3-0.6,2.4v0.5c0,1,0.2,1.8,0.6,2.4s0.9,0.8,1.6,0.8c0.7,0,1.2-0.3,1.6-0.8s0.6-1.3,0.6-2.4V15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M69.2,17c-0.1,1.1-0.5,1.9-1.2,2.5c-0.7,0.6-1.7,0.9-2.8,0.9c-1.3,0-2.3-0.4-3-1.3c-0.7-0.9-1.1-2-1.1-3.5V15 c0-1,0.2-1.8,0.5-2.5s0.8-1.3,1.4-1.7c0.6-0.4,1.4-0.6,2.2-0.6c1.1,0,2.1,0.3,2.8,0.9s1.1,1.5,1.2,2.6h-2.1c0-0.6-0.2-1.1-0.5-1.4 c-0.3-0.3-0.8-0.4-1.4-0.4c-0.7,0-1.2,0.2-1.5,0.7c-0.3,0.5-0.5,1.3-0.5,2.3v0.8c0,1.1,0.2,1.9,0.5,2.4c0.3,0.5,0.8,0.7,1.5,0.7 c0.6,0,1.1-0.1,1.4-0.4c0.3-0.3,0.5-0.7,0.5-1.3H69.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M73.6,16.3l-1.1,1.1v2.8h-2.1v-10h2.1v4.5l0.9-1.2l2.5-3.3h2.5L75,14.8l3.6,5.5h-2.4L73.6,16.3z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRock);
export default __webpack_public_path__ + "static/media/rock.186455b8aa836eead4ad3c567974b901.svg";
export { ForwardRef as ReactComponent };